import React, {useCallback, useState, useEffect} from "react";
import "../General/General.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import CancelModal from "../General/Cancel";
import DeleteModal from "../General/Delete"
import "../Clients/AddClients.css";
import {useLocation, useNavigate} from "react-router-dom";
import JiraProjectSearch from "../General/JiraProjectSearch";
import HarvestClientSearch from "../General/HarvestClientSearch";
import TextField from '@mui/material/TextField'
import keycloak from "../../Keycloak";
import {getClientById} from "../../utilities/ClientApi";
import Grid from '@mui/material/Grid';
import {Checkbox, FormControlLabel, Tooltip} from "@mui/material";
import Button from "@mui/material/Button";
import PhoneInput from "react-phone-input-2";
import MenuItem from '@mui/material/MenuItem';
import {modules} from "./AddClients";
import {showSaveError, showSaveSuccessMessage} from '../toastUtils';
import DragAndDropImages from "../DragAndDropImages";
import AgreementsTable from "./AgreementsTable";

const Status = [
    {
        value: 1,
        label: "Active",
    },
    {
        value: 2,
        label: "Inactive",
    },
];

const KYC = [
    {
        value: "true",
        label: "Yes",
    },
    {
        value: "false",
        label: "No",
    },
];

const countries = [
    {
        value: "",
        label: "Select country",
    },
    {
        value: "USA",
        label: "United States Of America",
    },
    {
        value: "UK",
        label: "United Kingdom",
    },
    {
        value: "AUS",
        label: "Australia",
    },
    {
        value: "RSA",
        label: "South Africa",
    },
];

const EditClient = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const clientId = searchParams.get('clientId');

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 50,
            },
        },
    };

    const [data, setData] = useState({
        clientId: 0,
        clientName: "",
        jiraSpace: "",
        businessName: "",
        registrationNum: "",
        companyStatus: 0,
        kycValidated: false,
        jiraProjectId: 0,
        harvestClientId: 0,
        address: {
            id:0,
            addressLine1: "",
            addressLine2: "",
            country: "",
            province: "",
            postalCode: 0,
        },
        keyContact: {
            id: 0,
            name: "",
            surname: "",
            email: "",
            contactNumber: "",
            employmentRole: ""
        },
        jiraProject: {
            id: 0,
            name: "",
        },
        timeTrackingClient: {
            clientId: 0,
            name: ""
        },
        introducer: {
            id: 0,
            name: "",
            surname: "",
            email: "",
            contactNumber: "",
            terms: ""
        },
        documents:[{
            fileName: "",
            fileType: "",
            fileBytes: null}],
        clientModules: {
            recruit: false,
            insights: false
        },
        companyLogo: {
            imageName: "",
            fileTpe: "",
            imageBytes: null}
    });

    const handleCheckboxChange = (event, value) => {
        setData((prevData) => ({
            ...prevData,
            clientModules: {
                ...prevData.clientModules,
                [value] : event.target.checked
            }
        }));
        setEnableSave(true)
    };

    const [KeyContactPhoneNumber, setPhoneNumber1] = useState('');
    const [valid1, setValid1] = useState(true);
    const [uploadedImageFiles, setUploadedImageFiles] = useState(null);
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [initialDocuments, setInitialDocuments] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleKeyContactPhoneNumberChange = (value) => {
        setPhoneNumber1(value);
        console.log(KeyContactPhoneNumber)
        setValid1(validatePhoneNumber(value));
        data.keyContact.contactNumber = value;
        setEnableSave(true);
    };

    const [introducerPhoneNumber, setPhoneNumber2] = useState('');
    const [valid2, setValid2] = useState(true);

    const handleIntroducerPhoneNumberChange = (value) => {
        setPhoneNumber2(value);
        console.log(introducerPhoneNumber)
        setValid2(validatePhoneNumber(value));
        data.introducer.contactNumber = value;
        setEnableSave(true);
    };

    const validatePhoneNumber = (phoneNumber) => {
        const countryCode = String(phoneNumber).substring(0, 2);
        const phoneNumberPattern = countryCode === "27" ? /^\+?\d{11}$/ : /^\+?[1-9]\d{1,14}$/;
        return phoneNumberPattern.test(phoneNumber);
    };

    const handleIntroducerEmailChange = e => {
        setIntroEmail(e.target.value);
        console.log(introEmail)
        setValidIntroEmail(validateEmail(e.target.value));
        handleChange(e);
        setEnableSave(true);
    }

    const handleKeyContactEmailChange = e => {
        setKeyContactEmail(e.target.value);
        console.log(keyContactEmail)
        setValidKeyContactEmail(validateEmail(e.target.value));
        handleChange(e);
        setEnableSave(true);
    }

    const validateEmail = email => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

    const [keyContactEmail, setKeyContactEmail] = useState('');
    const [validKeyContactEmail, setValidKeyContactEmail] = useState(true);
    const [introEmail, setIntroEmail] = useState('');
    const [validIntroEmail, setValidIntroEmail] = useState(true);
    const [enableSave, setEnableSave] = useState(false);

    /**
     * Update the state of the form data when an input field is changed.
     *
     * @param e
     */
    const handleChange = e => {
        // Fetch name and value from changed element
        let { name, value } = e.target;

        // If the name includes ".", it is a nested object
        if (name.includes(".")) {
            // Get the nested attribute
            const [nestedObject, nestedProperty] = name.split(".", 2);

            // Update the value and name to accommodate nested objects
            value = assignPartialObject(data[nestedObject], { [nestedProperty]: value });
            name = nestedObject;
        }

        // Update the state of the form data
        setData({...data, [name]: value})

        // Allow user to save form
        setEnableSave(true);
    }

    const handleDocumentUpdate = (newDocuments) => {
        setUploadedDocuments(newDocuments);
        setEnableSave(true);
    };

    const handleCompanyLogoUpload = (file) => {
        if(file) {
            setUploadedImageFiles(file);
            setEnableSave(true);
        }
    }

    /**
     * Add or update only some of the attributes of an existing object.
     *
     * @param existingObject
     * @param newObject
     * @returns object
     */
    const assignPartialObject = (existingObject, newObject) => {
        return Object.assign(existingObject, newObject);
    }

    const callClientInfo = useCallback(() => {
        getClientById(clientId, keycloak.token)
            .then((client) => {
                console.log("Client: ", client)
                setData(client);
                setInitialDocuments(client.documents);
            })
            .catch((e) => {
                console.log(e);
            })
    }, [setData, clientId])

    useEffect(() => {
        callClientInfo();
    }, [callClientInfo])

    const [openModal, setOpenModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const style = {
        "& label.Mui-focused": {
            color: "#EC8D2B",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#EC8D2B",
            },
        },
    };

    // TODO test
    const updateClientDetails = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        const headers = new Headers();

        headers.append('Authorization', 'Bearer ' + keycloak.token);
        headers.append('Content-Type', 'application/json')

        try{
            if (!openModal) {
                if (uploadedDocuments.length > 0) {
                    let documents = [];
                    for (const element of uploadedDocuments) {
                        if (element.blob) {
                            const file = element.blob;
                            const fileBytes = await readFileAsArrayBuffer(file);

                            documents.push({
                                id: element.id,
                                fileName: element.name,
                                fileType: file.type,
                                fileBytes: Array.from(new Uint8Array(fileBytes)),
                                fileStatus: element.fileStatus
                            });
                        } else {
                            documents.push({
                                id: element.id,
                                fileName: element.name,
                                fileBytes: [],
                                fileStatus: element.fileStatus
                            });
                        }
                    }

                    data.documents = documents;
                }

                // Append company logo if it exists
                if (uploadedImageFiles && uploadedImageFiles.length > 0) {
                    for (const file of uploadedImageFiles) {
                        const fileBytes = await readFileAsArrayBuffer(file);
                        data.companyLogo = {
                            imageName: file.name,
                            fileTpe: file.type,
                            imageBytes: Array.from(new Uint8Array(fileBytes)),
                        };
                    }
                } else {
                    data.companyLogo = null;
                }

                data.jiraProjectId = data.jiraProject.id;
                data.harvestClientId = data.timeTrackingClient.clientId;

                const response = await fetch(`api/client/${data.clientId}`, {
                    method: "PUT",
                    body: JSON.stringify(data),
                    headers: headers
                })

                if(response.ok){
                    const responseData = await response.json();
                    console.log(responseData);
                    showSaveSuccessMessage(`${data.clientName} has been successfully updated.`);
                    navigate("/ClientList");
                }
            }
        } catch (err) {
            console.log("try...catch: ", err);
            showSaveError("An error occurred, please try again");
            window.scrollTo(0, 0);
        } finally {
            setIsSubmitting(false);
        }
    }

    function readFileAsArrayBuffer(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsArrayBuffer(file);
        });
    }

    const setHarvestClientId = (harvestClientId, harvestClientName) => {
        data.harvestClientId = harvestClientId;
        data.clientName = harvestClientName;
        console.log("Harvest client id: ", data.harvestClientId);
        console.log("client name: ", data.clientName);
        console.log(data)
        setEnableSave(true);
    };

    const setJiraProjectId = jiraProjectId => {
        data.jiraProjectId = jiraProjectId;
        console.log('argument from Child: ', data.jiraProjectId);
        console.log(data);
        setEnableSave(true);
    };

    return (
        <div data-testid='OuterMostDiv' className="OuterMostDiv outerMostDivContainer">
            <form onSubmit={updateClientDetails} encType="multipart/form-data" method="POST" autoComplete="off">
                <div>
                    <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"} spacing={2}
                          className="gridPadding">
                        <Grid item xs={2}/>
                        <Grid item xs={10}>
                            <h4 data-testid='EditClientHeading'> Edit {data.clientName}</h4>
                        </Grid>

                        <Box sx={{flexGrow: 1}}
                             xs={12}
                             className="box-formatting"
                        >
                            <Paper
                                className="cardWidth" elevation={4}>
                                <h4>Modules</h4>
                                <Grid container direction="row" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={2}>
                                    {modules.map((moduleOptions) => (
                                        <Grid item xs={2} key={moduleOptions.value}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox data-testid={`edit-module-checkbox-${moduleOptions.value}`}
                                                              checked={data.clientModules?.[moduleOptions.value] || false}
                                                              sx={{'&.Mui-checked': {color: "#FF6600",},}}
                                                              onChange={(e) => handleCheckboxChange(e, moduleOptions.value)}
                                                    />
                                                }
                                                label={moduleOptions.label}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Paper>

                            <Paper className="Paper cardWidth elevation1" elevation={1}
                                   data-testid={"EditClientBasicDetails"}>
                                <div className="HeadingTypography">Basic details</div>
                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12} data-testid='HarvestClientSearchBox'>
                                        {data.timeTrackingClient.clientId !== 0 &&
                                            <HarvestClientSearch harvestClientId={data.timeTrackingClient.clientId}
                                                                 harvestClientName={data.timeTrackingClient.name}
                                                                 onChangeMethod={setHarvestClientId}
                                            />}
                                    </Grid>

                                    <Grid item xs={12} data-testid='JiraProjectSearchBox'>
                                        {data.jiraSpace !== "" &&
                                            <JiraProjectSearch jiraProjectId={data.jiraProject.id}
                                                               jiraProjectName={data.jiraProject.name}
                                                               onChangeMethod={setJiraProjectId}
                                            />}
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            required={true}
                                            id="businessName"
                                            data-testid={"businessName"}
                                            name="businessName"
                                            sx={style}
                                            label="Legal Business name"
                                            variant="outlined"
                                            onChange={e => handleChange(e)}
                                            value={data.businessName}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            id="registrationNum"
                                            data-testid={"registrationNum"}
                                            required={true}
                                            name="registrationNum"
                                            sx={style}
                                            label="Business registration number"
                                            variant="outlined"
                                            onChange={e => handleChange(e)}
                                            value={data.registrationNum}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            id="companyStatus"
                                            data-testid={"companyStatus"}
                                            sx={style}
                                            required={true}
                                            select
                                            name={"companyStatus"}
                                            onChange={e => handleChange(e)}
                                            value={data.companyStatus}
                                            label="Company Status"
                                            SelectProps={{
                                                native: true,
                                            }}
                                        >
                                            {Status.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="kycValidated"
                                            data-testid={"kycValidated"}
                                            select
                                            label="KYC Validated?"
                                            onChange={e => handleChange(e)}
                                            name={"kycValidated"}
                                            value={data.kycValidated}
                                            SelectProps={{
                                                native: true,
                                            }}
                                        >
                                            {KYC.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper
                                elevation={2}
                                className="cardWidth"
                                style={{
                                    height: "498px",
                                }}
                                data-testid={"EditClientCompanyAddress"}
                            >
                                <div className="HeadingTypography">Company Address</div>
                                <Grid container className="ParagraphPadding" direction="column"
                                      justifyContent={"flex-start"} alignItems={"stretch"} spacing={2} padding={5}>
                                    <Grid item xs={12}>
                                        <TextField
                                            sx={style}
                                            id="addressLine1"
                                            data-testid={"addressLine1"}
                                            label="Address Line 1"
                                            name={"address.addressLine1"}
                                            required={true}
                                            onChange={e => handleChange(e)}
                                            value={data.address.addressLine1}
                                            InputLabelProps={{shrink: true}}
                                            placeholder={"Enter address line 1"}
                                            variant="outlined"
                                            className="inputWidth"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="addressLine2"
                                            data-testid={"addressLine2"}
                                            required={true}
                                            label="Address Line 2"
                                            name={"address.addressLine2"}
                                            onChange={e => handleChange(e)}
                                            value={data.address.addressLine2}
                                            InputLabelProps={{shrink: true}}
                                            placeholder={"Enter address line 2"}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            sx={style}
                                            className="inputWidth"
                                            id="country"
                                            data-testid={"country"}
                                            select
                                            required={true}
                                            label="Country"
                                            name={"address.country"}
                                            onChange={e => handleChange(e)}
                                            value={data.address.country}
                                            InputLabelProps={{shrink: true}}
                                            placeholder={"Select country"}
                                            MenuProps={MenuProps}
                                        >
                                            {countries.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            sx={style}
                                            id="province"
                                            data-testid={"province"}
                                            label="Province/State"
                                            required={true}
                                            InputLabelProps={{shrink: true}}
                                            placeholder={"Select province/state"}
                                            name={"address.province"}
                                            onChange={e => handleChange(e)}
                                            value={data.address.province}
                                            variant="outlined"
                                            className="inputWidth"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            sx={style}
                                            id="postalCode"
                                            data-testid={"postalCode"}
                                            label="Postal Code"
                                            required={true}
                                            name={"address.postalCode"}
                                            onChange={e => handleChange(e)}
                                            value={data.address.postalCode}
                                            InputLabelProps={{shrink: true}}
                                            placeholder="Enter Postal Code"
                                            variant="outlined"
                                            className="inputWidth"
                                        />{" "}
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper
                                elevation={3}
                                className="cardWidth"
                                style={{
                                    height: "505px",
                                }}
                                data-testid={"EditClientKeyContacts"}
                            >
                                <div className="HeadingTypography">Key Contact</div>

                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item>
                                        <TextField
                                            id="keyContactName"
                                            data-testid={"keyContactName"}
                                            label="Name"
                                            required={true}
                                            name={"keyContact.name"}
                                            onChange={e => handleChange(e)}
                                            sx={style}
                                            variant="outlined"
                                            className="inputWidth"
                                            value={data.keyContact.name}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id="keyContactSurname"
                                            data-testid={"keyContactSurname"}
                                            sx={style}
                                            label="Surname"
                                            required={true}
                                            name={"keyContact.surname"}
                                            onChange={e => handleChange(e)}
                                            value={data.keyContact.surname}
                                            variant="outlined"
                                            className="inputWidth"
                                        />{" "}
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            id="keyContactEmail"
                                            sx={style}
                                            name={"keyContact.email"}
                                            inputProps={{
                                                required: true,
                                            }}
                                            onChange={handleKeyContactEmailChange}
                                            data-testid={"keyEmail"}
                                            value={data.keyContact.email}
                                            label="Email"
                                            variant="outlined"
                                            className="inputWidth"
                                        />
                                        {!validKeyContactEmail && (
                                            <p className={"text-danger"}>Please enter a valid email address.</p>
                                        )}
                                    </Grid>
                                    <Grid item>
                                        <PhoneInput
                                            className="inputWidth"
                                            sx={style}
                                            data-testid={"phone-number"}
                                            id="keyContactNumber"
                                            name={"keyContact.contactNumber"}
                                            containerStyle={{
                                                width: "100%",
                                                border: "#EC8D2B",
                                                color: "#EC8D2B",
                                            }}
                                            inputStyle={{
                                                width: "100%",
                                                height: "57px"
                                            }}
                                            label="Contact number"
                                            value={data.keyContact.contactNumber}
                                            onChange={handleKeyContactPhoneNumberChange}
                                            variant="outlined"
                                            country={'za'}
                                        />{!valid1 && (
                                        <p className={"text-danger"}>Please enter a valid phone number.</p>
                                    )}
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            className="inputWidth"
                                            id="keyContactEmploymentRole"
                                            data-testid={"keyContactEmploymentRole"}
                                            label="Employment role"
                                            name={"keyContact.employmentRole"}
                                            required={true}
                                            onChange={e => handleChange(e)}
                                            value={data.keyContact.employmentRole}
                                            sx={style}
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper
                                elevation={4}
                                className="cardWidth"
                                style={{
                                    height: "507px",
                                }}
                                data-testid={"EditClientIntroducer"}
                            >
                                <div className="HeadingTypography">Introducer</div>
                                <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerName"
                                            data-testid={"introducerName"}
                                            name={"introducer.name"}
                                            onChange={e => handleChange(e)}
                                            value={data.introducer.name}
                                            label="Name"
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerSurname"
                                            data-testid={"introducerSurname"}
                                            name={"introducer.surname"}
                                            onChange={e => handleChange(e)}
                                            value={data.introducer.surname}
                                            label="Surname"
                                            variant="outlined"
                                        />{" "}
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerEmail"
                                            name={"introducer.email"}
                                            onChange={handleIntroducerEmailChange}
                                            data-testid={"introEmail"}
                                            value={data.introducer.email}
                                            label="Email"
                                            variant="outlined"
                                        />
                                        {!validIntroEmail && (
                                            <p className={"text-danger"}>Please enter a valid email address.</p>
                                        )}
                                    </Grid>
                                    <Grid item>
                                        <PhoneInput
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerContactNumber"
                                            name={"introducer.contactNumber"}
                                            containerStyle={{
                                                width: "100%",
                                                border: "#EC8D2B",
                                                color: "#EC8D2B",
                                            }}
                                            inputStyle={{
                                                width: "100%",
                                                height: "57px"
                                            }}
                                            inputProps={{'data-testid': 'introducer-contact-number'}}
                                            value={data.introducer.contactNumber}
                                            label="Contact number"
                                            variant="outlined"
                                            country={'za'}
                                            onChange={handleIntroducerPhoneNumberChange}
                                        /> {!valid2 && (
                                        <p className={"text-danger"}>Please enter a valid phone number.</p>
                                    )}
                                    </Grid>
                                    <Grid item>
                                        <TextField
                                            className="inputWidth"
                                            sx={style}
                                            id="introducerTerms"
                                            data-testid={"introducerTerms"}
                                            name={"introducer.terms"}
                                            onChange={e => handleChange(e)}
                                            value={data.introducer.terms}
                                            label="Terms"
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper
                                elevation={5}
                                className="cardWidth"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flexGrow: 1,
                                    minHeight: "100px",
                                    overflowY: "hidden"
                                }}
                            >
                                <AgreementsTable
                                    documentNames={initialDocuments}
                                    handleDocumentUpdate={handleDocumentUpdate}
                                />
                            </Paper>
                            <Paper
                                className="cardWidth"
                                elevation={5}
                                style={{
                                    height: "294px",
                                }}
                            >
                                <h4>Company Logo</h4>
                                <DragAndDropImages
                                    inputUpdated={handleCompanyLogoUpload}
                                    allowedFileTypes={['SVG', 'PNG', 'JPG', 'GIF']}
                                    maxFileSize={3 * 1024 * 1024} // 3MB
                                />
                            </Paper>
                        </Box>
                        <Box style={{marginTop: "20px"}} xs={12}>
                            <Paper
                                className="cardWidth" style={{backgroundColor: "#F6F6F6", border: "0"}}>
                                <div className="d-inline-block float-end buttonPadding editSaveButtonPadding">
                                    <Tooltip disableHoverListener={enableSave}
                                             title={"Save button disabled if there are no changes made"}>
                                            <span>
                                                <Button
                                                    data-testid={"save-button"}
                                                    type="submit"
                                                    variant="contained"
                                                    className="SaveButton"
                                                    style={{
                                                        background: (enableSave && !isSubmitting) ? '#ec8d2b' : '#DDDDDD',
                                                        color: (enableSave && !isSubmitting) ? '#FFFFFF' : '#AAAAAA',
                                                        fontWeight: "bold"

                                                    }}
                                                    disabled={!enableSave}
                                                >
                                                    {" "}
                                                    {isSubmitting ? "Saving..." : "SAVE"}
                                            </Button>
                                            </span>
                                    </Tooltip>
                                </div>
                                <div className="d-inline-block float-end buttonPadding editCancellButtonPadding">
                                    <button
                                        className="CancelButton"
                                        variant="outlined"
                                        onClick={() => {
                                            setOpenModal(true);
                                        }}
                                    >
                                        CANCEL
                                    </button>
                                    <CancelModal
                                        open={openModal}
                                        onClose={() => setOpenModal(false)}
                                    />
                                </div>
                                <div className="d-inline-block float-end buttonPadding editDeleteButtonPadding">
                                    <button
                                        variant="outlined"
                                        className="DeleteButton"
                                        onClick={() => {
                                            setOpenDeleteModal(true);
                                        }}
                                    >
                                        DELETE
                                    </button>
                                    <DeleteModal
                                        open={openDeleteModal}
                                        onClose={() => setOpenDeleteModal(false)}
                                    />
                                </div>
                            </Paper>
                        </Box>
                    </Grid>
                </div>
            </form>
        </div>
    );
};

export default EditClient;